export function parseTranscript(transcript) {
  if (!transcript) return []

  const lines = transcript.split('\n')
  const messages = []

  for (const line of lines) {
    const trimmedLine = line.trim()

    if (!trimmedLine ||
        trimmedLine.startsWith('[') ||
        trimmedLine.startsWith('{') ||
        trimmedLine.startsWith('<function:')) {
      continue
    }

    if (trimmedLine.startsWith('aimee:')) {
      messages.push({
        text: trimmedLine.substring(6).trim(),
        isAimee: true
      })
    } else if (trimmedLine.startsWith('patient/speaker:')) {
      messages.push({
        text: trimmedLine.substring(16).trim(),
        isAimee: false
      })
    } else if (trimmedLine.startsWith('user:')) {
      messages.push({
        text: trimmedLine.substring(5).trim(),
        isAimee: false
      })
    }
  }

  return messages
}

export function getMessageCount(transcript) {
  const messages = parseTranscript(transcript)
  return messages.length
}

export function getConversationPreview(transcript, maxMessages = 2, maxLength = 40) {
  const messages = parseTranscript(transcript)

  if (messages.length === 0) return ['No valid messages']

  return messages.slice(0, maxMessages).map(message => {
    const speaker = message.isAimee ? 'Aimee' : 'Patient'
    const text = message.text.length > maxLength
      ? message.text.substring(0, maxLength) + '...'
      : message.text
    return `${speaker}: ${text}`
  })
}

export function downloadConversationTranscript(conversation, formatDate) {
  if (!conversation?.transcript) return false

  const header = `Aimee Conversation Transcript
Date: ${formatDate(conversation.created_at)}
Patient ID: ${conversation.patient_monitor.patient.id}
Room: ${conversation.patient_monitor.room.name}
Hospital: ${conversation.patient_monitor.division.name}
Prompt Name: ${conversation.aimee_prompt?.name || 'N/A'}
Source: ${conversation.source}
${conversation.ended_at ? `Ended: ${formatDate(conversation.ended_at)}` : 'Status: Active'}

--- Raw Conversation ---

`

  const fullContent = header + conversation.transcript

  const blob = new Blob([fullContent], { type: 'text/plain' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url

  const date = formatDate(conversation.created_at, 'YYYY-MM-DD')
  const patientId = `patient-${conversation.patient_monitor.patient.id}`
  const room = `room-${conversation.patient_monitor.room.name}`.replace(/[^a-zA-Z0-9]+/g, '-')

  link.download = `aimee_conversation_${date}_${patientId}_${room}.txt`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)

  return true
} 